import { SavePrivateBillRequestModel } from "./SavePrivateBillRequestModel";

class SaveAndPrintPrivateBillRequestModel extends SavePrivateBillRequestModel {
    public PatientContactId: string;
    public constructor(init?: Partial<SaveAndPrintPrivateBillRequestModel>) {
        super(init);
        Object.assign(this, init);
    }
}

export { SaveAndPrintPrivateBillRequestModel };
